var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 66"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#30a8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(2.8571 2.8696)",
    d: "m10.339 0.73781c4.4188 0 7.9994 3.527 7.9994 7.8777 0 7.3999 1.601 8.6645 1.601 8.6645h-19.201s1.5996-2.012 1.5996-8.6645c0-4.3506 3.582-7.8777 8.0008-7.8777z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(2.8571 2.8696)",
    fill: "none",
    d: "m8.2031 20.484c0.27754 0.93383 1.1471 1.575 2.1355 1.575 0.98848 0 1.858-0.64116 2.1355-1.575"
  }))));
};
export default SvgBell;